/*eslint-disable*/
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toPng } from "html-to-image";
import { setErrorNotification } from "../../../../redux/slices/NotificationSlice";
import ModalBox from "../../../../shared/component/ModalBox";
import TemplateContentUpload from "../TemplateContentUpload";
import HtmlHeader from "../HtmlHeader";
import utils from "../templateFunctions";
import { createOrUpdateTemplate } from "../../../../redux/slices/TemplateSlice";
import FileFormat from "../FileFormat";
import PopupBox from "../ContentUploadConfirmation";

function HtmlTemplateTwentyThree({ templateData }) {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [
    openContentUploadConfirmation,
    setOpenContentUploadConfirmation,
  ] = useState(false);
  const [base64, setBase64] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const [disable, setDisable] = useState(true);
  const [modalView, setModalView] = useState({ content: "", title: "" });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const htmlRef = useRef(null);
  const cssStyles = `
body {
    margin: 0;
    padding: 0;
}
@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Bold.ttf) format("truetype");
 font-weight: 700;
}

@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Medium.ttf) format("truetype");
 font-weight: 500;
}

@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Regular.ttf) format("truetype");
 font-weight: 400;
}

@font-face {
 font-family: "Great Vibes";
 src: url(../../../assets/fonts/greatVibes/GreatVibes-Regular.ttf) format("truetype");
 font-weight: 500;
}

.template-container-23 {
  width: 100%;
  box-sizing: border-box;
  height: 100vh;
  padding: 5px;
}

.template-container-23 .main-container .continer23 .certificate {
  position: relative;
  width: 100%;
  min-height: 100vh;
  text-align: center;
  background: linear-gradient(to bottom, #8b0c0c, #450202);
  color: rgba(255, 255, 255, 1);
  padding: 80px 20px;
  overflow: hidden;
}

/* Decorative Images */
.template-container-23 .main-container .continer23 .certificate .decor {
  position: absolute;
  pointer-events: none;
}

.template-container-23 .main-container .continer23 .certificate .decor.top-left {
  top: -44%;
  right: 0px;
  width: 100px;
}

.template-container-23 .main-container .continer23 .certificate .decor.top-right {
  top: -43%;
  left: 0px;
  width: 100px;
}

.template-container-23 .main-container .continer23 .certificate .decor.bottom-left {
  left: 0;
  width: 42%;
  top: 0px;
}

.template-container-23 .main-container .continer23 .certificate .decor.bottom-right {
  right: 0;
  width: 42%;
  top: 0px;
}

.template-container-23 .main-container .continer23 .certificate .decor.leaves {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(28%, -122%);
  width: 335px;
  z-index: 0;
}

/* Title */
.template-container-23 .main-container .continer23 .certificate .congrats {
  font-family: "Great Vibes", cursive;
  font-size: 42px;
  color: rgba(246, 239, 147, 1);
  margin-bottom: 10px;
}

.template-container-23 .main-container .continer23 .certificate .title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 40px;
}

/* Profile */
.template-container-23 .main-container .continer23 .certificate .profile {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.template-container-23 .main-container .continer23 .certificate .profile .photo-frame {
  width: 200px;
  height: 200px;
  border: 4px solid rgba(246, 239, 147, 1);
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.template-container-23 .main-container .continer23 .certificate .profile .photo-frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Banner */
.template-container-23 .main-container .continer23 .certificate .banner {
  margin: 20px auto 10px;
  background: rgba(246, 239, 147, 1);
  padding: 10px 30px;
  border-radius: 25px;
  display: inline-block;
  color: rgba(21, 19, 15, 1);
  font-size: 20px;
  font-weight: bold;
}

.template-container-23 .main-container .continer23 .certificate .role {
  font-size: 18px;
  font-style: italic;
  margin-bottom: 20px;
  margin-top: 60px;
}

/* Description */
.template-container-23 .main-container .continer23 .certificate .description {
  font-size: 16px;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.template-container-23 .main-container .continer23 .award-card {
  position: relative;
  width: 300px;
  margin: 0 auto;
  text-align: center;
  padding-top: 70px;
}

/* Profile Frame */
.template-container-23 .main-container .continer23 .award-card .photo-frame {
  width: 200px;
  height: 200px;
  border: 4px solid #E3BA60;
  border-radius: 50%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  z-index: 2;
}

.template-container-23 .main-container .continer23 .award-card .photo-frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Laurel Decorations */
.template-container-23 .main-container .continer23 .award-card .laurel {
  position: absolute;
  top: 75px;
  width: 120px;
  z-index: 1;
}

.template-container-23 .main-container .continer23 .award-card .laurel.left {
  left: 0px;
  transform: rotate(-10deg);
}

.template-container-23 .main-container .continer23 .award-card .laurel.right {
  right: 10px;
  transform: rotateY(150deg);
}

.template-container-23 .main-container .continer23 .award-card .laurel img {
  width: 100%;
}

/* Stars */
.template-container-23 .main-container .continer23 .award-card .star {
  position: absolute;
  top: 40px;
  font-size: 30px;
  color: #E3BA60;
}

.template-container-23 .main-container .continer23 .award-card .star.left {
  left: -5px;
}

.template-container-23 .main-container .continer23 .award-card .star.right {
  right: 10px;
}

/* Ribbon Banner */
.template-container-23 .main-container .continer23 .award-card .ribbon-container {
  background: url("https://res.cloudinary.com/dbn7o7n1o/image/upload/v1757893159/Clip_path_group_7_vrejjo.png") 100% 100% no-repeat;
  background-size: cover;
  width: 100%;
  position: absolute;
}

.template-container-23 .main-container .continer23 .award-card .ribbon-container .ribbon {
  background: #E3BA60;
  display: inline-block;
  padding: 10px 30px;
  z-index: 3;
  position: relative;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
  width: 80%;
}

.template-container-23 .main-container .continer23 .award-card .ribbon-container .ribbon .name {
  font-weight: bold;
  font-size: 18px;
  color: #000;
}

.template-container-23 .main-container .continer23 .award-card .ribbon-container .ribbon .name span {
  color: rgb(102, 17, 22);
}
  `;

  const convertImage = async (url) => {
    await utils
      .convertSignedUrl(url)
      .then((response) => {
        setDisable(false);
        dispatch(createOrUpdateTemplate(response));
      })
      .catch((error) => {
        setDisable(false);
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertBase64 = async () => {
    try {
      // Convert to base64
      const dataUrl = await toPng(htmlRef.current, { cacheBust: true });
      setBase64(dataUrl); // Set the base64 data
      convertImage(dataUrl); // Your function to handle the base64 data
    } catch (error) {
      dispatch(setErrorNotification(error?.response?.data));
    }
  };

  const convertHtml = () => {
    if (htmlRef.current) {
      const content = htmlRef.current.outerHTML;
      const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />           
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
      setHtmlContent(fullHtml); // Set the HTML content as a string
    }
  };

  useEffect(() => {
    utils?.initializer(templateData).then((res) => setData(res));
    utils?.reload();
  }, [templateData]);

  /* useEffect runs convertBase64 after data is updated */
  useEffect(() => {
    if (data) {
      setTimeout(() => {
        convertBase64();
      }, 1000);
      convertHtml();
    }
  }, [data]);

  const handleFileType = (fileType) => {
    setModalView({
      title: "content",
      content: (
        <TemplateContentUpload
          base64={base64}
          setNotification={setNotification}
          fileType={fileType}
          htmlContent={htmlContent}
        />
      ),
    });
  };

  const onClickContentUpload = () => {
    setNotification(true);
    setModalView({
      title: t("fileFormat"),
      content: (
        <FileFormat
          setNotification={setNotification}
          handleFileType={handleFileType}
          setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
          data={data}
        />
      ),
    });
  };
  const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details;
  const styles = data?.[0]?.styles?.details;
  const backgroundColor = data?.[0]?.styles?.background;
  return (
    <div>
      <HtmlHeader
        htmlData={data}
        disable={disable}
        click={onClickContentUpload}
      />

      <ModalBox
        status={notification}
        closeModal={setNotification}
        modalView={modalView}
      />
      <ModalBox
        status={openContentUploadConfirmation}
        closeModal={setOpenContentUploadConfirmation}
        modalView={{
          title: "Confirmation",
          content: (
            <PopupBox
              setOpenContentUploadConfirmation={
                setOpenContentUploadConfirmation
              }
              setNotification={setNotification}
            />
          ),
        }}
      />
      <div className="header-height" />
      <div
        ref={htmlRef}
        className="template-container-23"
        style={{ backgroundColor: backgroundColor }}
      >
        <div className="main-container">
          <div className="continer23">
            <div className="certificate">
              <img src="https://res.cloudinary.com/dbn7o7n1o/image/upload/v1757861684/Clip_path_group_6_ulboxh.png"
                alt="Top Right" className="decor top-right" />
              <img src="https://res.cloudinary.com/dbn7o7n1o/image/upload/v1757596260/Clip_path_group_ry2hqm.png"
                alt="Top Left" className="decor top-left" />
              <h2 className="congrats"
                style={{
                  color: styles?.[0]?.color,
                  fontSize: styles?.[0]?.fontSize,
                  fontFamily: styles?.[0]?.fontFamily,
                }}
              >
                Congratulations
                </h2>
              <h1 className="title"
                style={{
                  color: styles?.[1]?.color,
                  fontSize: styles?.[1]?.fontSize,
                  fontFamily: styles?.[1]?.fontFamily,
                }}>{contentDetails?.[0].heading}</h1>

              <div className="award-card">
                <div className="photo-frame">
                  <img src={contentDetails?.[0].image} alt="Thomas Muller" />
                </div>

                <div className="laurel left">
                  <img
                    src="https://res.cloudinary.com/dbn7o7n1o/image/upload/v1757596376/Clip_path_group_4_x71hdu.png"
                    alt="Laurel Right"
                  />
                </div>
                <div className="laurel right">
                  <img
                    src="https://res.cloudinary.com/dbn7o7n1o/image/upload/v1757596376/Clip_path_group_4_x71hdu.png"
                    alt="Laurel Right"
                  />
                </div>
                <span className="star left">★</span>
                <span className="star right">★</span>
                <div className="ribbon-container">
                  <div className="ribbon">
                    <span className="name"><span>★</span>{contentDetails?.[0].name}<span>★</span></span>
                  </div>
                </div>
              </div>
              <p className="role">{contentDetails?.[0].role}</p>

              <p className="description">{contentDetails?.[0].description}</p>
              <img
                src="https://res.cloudinary.com/dbn7o7n1o/image/upload/v1757596367/Clip_path_group_3_usprie.png"
                alt="Bottom Left"
                className="decor bottom-left"
              />
              <img
                src="https://res.cloudinary.com/dbn7o7n1o/image/upload/v1757596367/Clip_path_group_3_usprie.png"
                alt="bottom-right"
                className="decor bottom-right"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HtmlTemplateTwentyThree.propTypes = {
  templateData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    template_title: PropTypes.string.isRequired,
  }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateTwentyThree;
